

/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import axios from "axios";

import { fetchPermissions } from "../redux/slices/branch/permissionManagerSlice";
import { fetchUserProfile } from "../redux/slices/branch/userProfileSlice";

import "../assets/css/dashboard.css";

import {
  FaUserFriends,
  FaMoneyCheckAlt,
  FaSearch,
  FaClipboardList,
  FaFileInvoice,
  FaPlus,
} from "react-icons/fa";

export default function BranchDashboard() {
  const dispatch = useDispatch();
  const { profile } = useSelector((state) => state.userProfile);

  const storedUserId = localStorage.getItem("userId");
  const userId = storedUserId ? Number(storedUserId) : null;

  const [collectionData, setCollectionData] = useState({});
  const [pendingCollectionData, setPendingCollectionData] = useState({});
  const [disbursementData, setDisbursementData] = useState({});
  const [company,setCompany]=useState(null)
  const [loading, setLoading] = useState(true);
  const [totalDashboardData,setTotalDashboardData] = useState({});

  const formatINR = (value = 0) =>
    `₹ ${Number(value || 0).toLocaleString("en-IN")}`;

  /* ---------------- LOAD PROFILE & PERMISSIONS ---------------- */
  useEffect(() => {
    dispatch(fetchUserProfile());
  }, [dispatch]);

  useEffect(() => {
    if (userId) dispatch(fetchPermissions(userId));
  }, [dispatch, userId]);

  // Fetch Company
  useEffect(()=>{
    const fetchCompany=async()=>{
      try {
        const res = await fetch(
            `https://narrowitsolution.in/api/get-company?superAdminId=${profile.superAdminId}`
          );
          const data = await res.json();
          if (res.ok) {
            if (data.logo)
              data.logoUrl = `https://narrowitsolution.in/${data.logo.replace(
                /^images\//,
                ""
              )}`;
              // console.log("company",data)
            setCompany(data);
          }
      } catch (error) {
        console.log("Company fetching error:",error)
      }
    }

    fetchCompany()
  },[profile])

  /* ---------------- COLLECTION ---------------- */
  const fetchCollection = async () => {
    const res = await axios.get(
      "https://narrowitsolution.in/api/dashboard-collection/api",
      {
        params: {
          superAdminId: profile.superAdminId,
          branchId: profile.id,
        },
      },
    );
    // console.log("collection",res.data)
    setCollectionData(res.data?.data || {});
  };

  /* ---------------- PENDING COLLECTION ---------------- */
  const fetchPendingCollection = async () => {
    const res = await axios.get("https://narrowitsolution.in/api/dashboard-list/", {
      params: {
        superAdminId: profile.superAdminId,
        branchId: profile.id,
      },
    });
    // console.log("pending collection",res.data)
    setPendingCollectionData(res.data?.data || {});
  };

  /* ---------------- DISBURSEMENT (FIXED LOGIC) ---------------- */
  const fetchDisbursement = async () => {
    const filters = ["today", "week", "month", "year"];

    let disbursedTemp = {};
    let pendingTemp = {};

    let disbursedTotal = 0;
    let pendingTotal = 0;

    for (let f of filters) {
      const res = await axios.get(
        "https://narrowitsolution.in/api/dashbaord/loan-summery/disbursment",
        {
          params: {
            superAdminId: profile.superAdminId,
            filter: f,
          },
        },
      );

      // console.log("disbursement",res.data)
      const disbursedAmount = res.data?.data?.disbursed?.amount || 0;

      const pendingAmount = res.data?.data?.pendingDisbursement?.amount || 0;

      disbursedTemp[f] = disbursedAmount;
      pendingTemp[f] = pendingAmount;

      disbursedTotal += disbursedAmount;
      pendingTotal += pendingAmount;
    }

    setDisbursementData({
      disbursed: {
        today: disbursedTemp.today,
        weekly: disbursedTemp.week,
        monthly: disbursedTemp.month,
        yearly: disbursedTemp.year,
        total: disbursedTotal,
      },
      pending: {
        today: pendingTemp.today,
        weekly: pendingTemp.week,
        monthly: pendingTemp.month,
        yearly: pendingTemp.year,
        total: pendingTotal,
      },
    });
  };

  const fetchDashboardTotal = async () => {
    if(!profile?.superAdminId)
       return ; 
    try{
       const res= await axios.get(`https://narrowitsolution.in/api/all-dashboard/customer/branch?branchId=${profile.id}`);
       if(res)
       {
        // console.log(res);
        setTotalDashboardData(res.data);
       }
     }
    catch(error){
        console.log(error);
    }
  }

  /* ---------------- LOAD DASHBOARD ---------------- */
  useEffect(() => {
    if (!profile?.superAdminId || !profile?.id) return;

    setLoading(true);
    Promise.all([
      fetchCollection(),
      fetchPendingCollection(),
      fetchDisbursement(),
      fetchDashboardTotal(),
    ]).finally(() => setLoading(false));
  }, [profile]);


  if (loading) return <p className="loading-text">Loading dashboard...</p>;
  // console.log("total loans are", totalDashboardData.data.loans.others)
  /* ---------------- UI DATA ---------------- */
  // const kpiData = [
  //   {
  //     label: "Total Customers",
  //     value: totalDashboardData.data.totalCustomers,
  //     color: "#2aa9b8",
  //     icon: <FaUserFriends />,
  //   },
  //   {
  //     label: "Total Active Loans",
  //     value: `${totalDashboardData.data.totalLoans}`,
  //     color: "#d9c39a",
  //     icon: <FaMoneyCheckAlt />,
  //   },
  //   {
  //     label: "Today Due Emi",
  //     value: `${totalDashboardData.data.loans.active}`,
  //     color: "#d9c39a",
  //     icon: <FaMoneyCheckAlt />,
  //   },
  //   {
  //     label: "Today Collection",
  //     value: "₹ 0",
  //     color: "#d9c39a",
  //     icon: <FaMoneyCheckAlt />,
  //   },
  //   {
  //     label: "Total Saving Account",
  //     value: `${totalDashboardData.data.totalSavingAccounts}`,
  //     color: "#933811",
  //     icon: <FaMoneyCheckAlt />,
  //   },
  //   {
  //     label: "Total FD Account",
  //     value: `${totalDashboardData.data.fdMisAccounts.fd}`,
  //     color: "#933811",
  //     icon: <FaMoneyCheckAlt />,
  //   },
  //    {
  //     label: "Total MIS Account",
  //     value: `${totalDashboardData.data.fdMisAccounts.mis}`,
  //     color: "#933811",
  //     icon: <FaMoneyCheckAlt />,
  //   },
  //    {
  //     label: "Total RD Account",
  //     value: `${totalDashboardData.data.depositAccounts.rd}`,
  //     color: "#933811",
  //     icon: <FaMoneyCheckAlt />,
  //   },
  //    {
  //     label: "Total DD Account",
  //     value: `${totalDashboardData.data.depositAccounts.dd}`,
  //     color: "#933811",
  //     icon: <FaMoneyCheckAlt />,
  //   },
     

  // ];


  const kpiData = [
    {
      label: "Total Customers",
      value: totalDashboardData?.data?.totalCustomers ?? 0,
      color: "#2aa9b8",
      icon: <FaUserFriends />,
    },
    {
      label: "Total Active Loans",
      value: totalDashboardData?.data?.loans?.active ?? 0,
      color: "#d9c39a",
      icon: <FaMoneyCheckAlt />,
    },
    // {
    //   label: "Today Due Emi",
    //   // value: totalDashboardData?.data?.loans?.active ?? 0,
    //   value: 0,
    //   color: "#d9c39a",
    //   icon: <FaMoneyCheckAlt />,
    // },
    // {
    //   label: "Today Collection",
    //   value: totalDashboardData?.data?.todayCollection ?? "₹ 0",
    //   color: "#d9c39a",
    //   icon: <FaMoneyCheckAlt />,
    // },
    {
      label: "Total Saving Account",
      value: totalDashboardData?.data?.totalSavingAccounts ?? 0,
      color: "#933811",
      icon: <FaMoneyCheckAlt />,
    },
    {
      label: "Total FD Account",
      value: totalDashboardData?.data?.fdMisAccounts?.fd ?? 0,
      color: "#933811",
      icon: <FaMoneyCheckAlt />,
    },
    {
      label: "Total MIS Account",
      value: totalDashboardData?.data?.fdMisAccounts?.mis ?? 0,
      color: "#933811",
      icon: <FaMoneyCheckAlt />,
    },
    {
      label: "Total RD Account",
      value: totalDashboardData?.data?.depositAccounts?.rd ?? 0,
      color: "#933811",
      icon: <FaMoneyCheckAlt />,
    },
    {
      label: "Total DD Account",
      value: totalDashboardData?.data?.depositAccounts?.dd ?? 0,
      color: "#933811",
      icon: <FaMoneyCheckAlt />,
    },
  ];

  const quickAccess = [
    {
      label: "Create Customer",
      icon: <FaPlus />,
      link: "/Customers/add",
    },
    {
      label: "Search Customer",
      icon: <FaSearch />,
      link: "/Customers/SearchCustomer",
    },
    {
      label: "Customer Reports",
      icon: <FaFileInvoice />,
      link: "/CustomerReport",
    },
    {
      label: "Loan Apply",
      icon: <FaClipboardList />,
      link: "/Loan/PersonalLoanForm",
    },

    {
      label: "Loan Reports",
      icon: <FaFileInvoice />,
      link: "/Loan/LoanReport",
    },
  ];

  const overviewData = [
    {
      title: "Collection",
      today: formatINR(collectionData.today),
      weekly: formatINR(collectionData.weekly),
      monthly: formatINR(collectionData.monthly),
      yearly: formatINR(collectionData.yearly),
      total: formatINR(collectionData.total),
    },
    {
      title: "Pending Collection",
      today: formatINR(pendingCollectionData.today),
      weekly: formatINR(pendingCollectionData.weekly),
      monthly: formatINR(pendingCollectionData.monthly),
      yearly: formatINR(pendingCollectionData.yearly),
      total: formatINR(pendingCollectionData.total),
    },
    {
      title: "Disbursement",
      today: formatINR(disbursementData?.disbursed?.today),
      weekly: formatINR(disbursementData?.disbursed?.weekly),
      monthly: formatINR(disbursementData?.disbursed?.monthly),
      yearly: formatINR(disbursementData?.disbursed?.yearly),
      total: formatINR(disbursementData?.disbursed?.total),
    },
    {
      title: "Pending Disbursement",
      today: formatINR(disbursementData?.pending?.today),
      weekly: formatINR(disbursementData?.pending?.weekly),
      monthly: formatINR(disbursementData?.pending?.monthly),
      yearly: formatINR(disbursementData?.pending?.yearly),
      total: formatINR(disbursementData?.pending?.total),
    },
    {
      title: "Created Loan",
      today: "₹ 0",
      weekly: "₹ 0",
      monthly: "₹ 0",
      yearly: "₹ 0",
      total: "₹ 0",
    },
    {
      title: "Opened Account",
      today: "₹ 0",
      weekly: "₹ 0",
      monthly: "₹ 0",
      yearly: "₹ 0",
      total: "₹ 0",
    },
  ];

  /* ---------------- JSX ---------------- */
  return (
    <div className="bd-dashboard-root">
      <div className="bd-dashboard-header">
        <div className="running-text ">
          <h1 className="gradient-text">Welcome, {company?.name||"Company Name"}, Branch({profile.branchName})</h1>
        </div>
      </div>

        {/* KPIs */}
        <section className="bd-kpi-card">
          <h2 className="bd-card-title">KPIs</h2>

          <div className="bd-kpi-list">
            {kpiData.map((kpi, index) => (
              <div className={`bd-kpi-row bd-kpi-${index + 1}`} key={index}>
                <div className="bd-kpi-icon">{kpi.icon}</div>

                <div className="bd-kpi-text">
                  <span className="bd-kpi-label">{kpi.label}</span>
                  <span className="bd-kpi-value">{kpi.value}</span>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* QUICK ACCESS */}
        <section className="bd-quick-card">
          <h2 className="bd-card-title">Quick Access</h2>

          <div className="bd-quick-grid">
            {quickAccess.map((item, index) => (
              <Link
                to={item.link}
                key={index}
                className={`bd-quick-item bd-quick-${index + 1}`}
              >
                {item.icon}
                <span>{item.label}</span>
              </Link>
            ))}
          </div>
        </section>

      {/* COLLECTION OVERVIEW */}
      <section className="bd-collection-section">
        <h2 className="bd-card-title">Collection & Overview</h2>

        <div className="bd-overview-grid">
          {overviewData.map((ov, index) => (
            <div
              className={`bd-overview-card bd-overview-${index + 1}`}
              key={index}
            >
              <h3 className="bd-overview-title">{ov.title}</h3>

              <div className="bd-overview-stats">
                <div className="bd-stat-row">
                  <span>Today</span>
                  <strong>{ov.today}</strong>
                </div>
                <div className="bd-stat-row">
                  <span>Weekly</span>
                  <strong>{ov.weekly}</strong>
                </div>
                <div className="bd-stat-row">
                  <span>Monthly</span>
                  <strong>{ov.monthly}</strong>
                </div>
                <div className="bd-stat-row">
                  <span>Yearly</span>
                  <strong>{ov.yearly}</strong>
                </div>

                <div className="bd-stat-total">
                  <span>Total</span>
                  <strong>{ov.total}</strong>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
